/* eslint-disable @typescript-eslint/naming-convention */
export const PURGE_DROPS = "@DROPS/PURGE_DROPS";
export type PURGE_DROPS = typeof PURGE_DROPS;

export const SET_DROP = "@DROPS/SET_DROP";
export type SET_DROP = typeof SET_DROP;

export const PURGE_USER_DROPS = "@DROPS/PURGE_USER_DROPS";
export type PURGE_USER_DROPS = typeof PURGE_USER_DROPS;

export const SET_USER_DROPS = "@DROPS/SET_USER_DROPS";
export type SET_USER_DROPS = typeof SET_USER_DROPS;
